module.exports = __webpack_public_path__ + "img/Alexa Yeagley.961b9f6d.jpg";